<template>
    <div class="http404">
        <div class="sp"></div>
        <img class="img1" src="@/assets/404/404.png" alt="">
        <a href="/"><img class="btn-back" src="@/assets/404/bt_back.png"><img></a>
    </div>
</template>

<script>

export default {
    data() {
        return {
        };
    },
};
</script>

<style scoped>
.http404 {
    height: 100%;
    /* background-color: rgb(252, 232, 217); */
}
.sp {
    width: 100%;
    height: 1px;
}
.img1 {
    display: block;
    margin: 200px auto 100px;
    width: 500px;
}
.btn-back {
    margin: auto;
    display: block;
    width: 200px;
    margin-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/404.vue